module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "popup",
      "tag": "div"
    }
  }, [(_vm.popupStatus) ? _c('div', {
    key: _vm.popupStatus,
    staticClass: "popup-model"
  }, [_c('div', {
    staticClass: "popup-bg",
    on: {
      "click": _vm.closePopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-header"
  }, [_vm._v("\n            " + _vm._s(_vm.popuptype === 'login' ? '登入' : '忘記密碼') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pop-content"
  }, [(_vm.popuptype === 'login') ? _c('Login') : _vm._e(), _vm._v(" "), (_vm.popuptype === 'fg') ? _c('ForgetPassword') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pop-close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")])])]) : _vm._e()]), _vm._v(" "), (_vm.pageLoadingStatus) ? _c('div', {
    staticClass: "loading",
    class: {
      'isShow': _vm.pageLoadingStatus === true
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._v(" OneAD © " + _vm._s(new Date().getFullYear()) + ". All rights reserved ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner_double"
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1ff92f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 134
// module chunks = 18